import React from 'react';
import { useLanguage } from '../../../context/language/LanguageContext';
import './InfoSection.css';

const InfoSection = () => {
    const { language } = useLanguage();

    return (
        <div className="info-section-container">
            <h2 className="info-section-title">
                {language === 'my' ? 'မဟာဝိဟာရ၏ အထူးအချက်များ' : 'Special Features of Mahãvihãra'}
            </h2>

            <div className="info-cards-grid">
                <div className="info-card">
                    <div className="icon-box">
                        <i className="fas fa-ban"></i>
                    </div>
                    <h3>
                        {language === 'my' ? 'တားမြစ်ထားသောပစ္စည်းများ' : 'Prohibited Items'}
                    </h3>
                    <ul>
                        <li>
                            {language === 'my' ? 'ဖုန်းနှင့် ကွန်ပျူတာများ' : 'Phones and computers'}
                        </li>
                        <li>
                            {language === 'my' ? 'ကိုယ်ပိုင်ငွေဖြင့် ဝယ်ယူထားသောပစ္စည်းများ' : 'Items purchased with personal money'}
                        </li>
                    </ul>
                </div>

                <div className="info-card">
                    <div className="icon-box">
                        <i className="fas fa-box-open"></i>
                    </div>
                    <h3>
                        {language === 'my' ? 'သံဃိကဘဏ္ဍာတိုက်' : 'Sanghika Treasury'}
                    </h3>
                    <ul>
                        <li>
                            {language === 'my' ? 'သပိတ်နှင့် သင်္ကန်းများ' : 'Alms bowls and robes'}
                        </li>
                        <li>
                            {language === 'my' ? 'စာအုပ်နှင့် သင်ထောက်ကူပစ္စည်းများ' : 'Books and study materials'}
                        </li>
                    </ul>
                </div>

                <div className="info-card">
                    <div className="icon-box">
                        <i className="fas fa-heart"></i>
                    </div>
                    <h3>
                        {language === 'my' ? 'စေတနာရှင်များ၏ထောက်ပံ့မှု' : 'Donor Support'}
                    </h3>
                    <ul>
                        <li>
                            {language === 'my' ? 'လိုအပ်သောပစ္စည်းများ ထောက်ပံ့ပေးခြင်း' : 'Provision of necessary items'}
                        </li>
                        <li>
                            {language === 'my' ? 'စဉ်ဆက်မပြတ် လှူဒါန်းခြင်း' : 'Continuous support'}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default InfoSection;